<template lang="pug">
  b-container(fluid)
    b-row
      b-col.page-wrap(cols="12")
        //b-alert(show, variant="light", v-html="$t('add_manager_desc')")
        b-card.w-100(no-body)
          div(slot="header") {{$t('add_user')}}
          b-list-group.list-input(flush)
            // 아이디
            b-list-group-item
              b-input-group
                //b-input-group-prepend(is-text)
                //  icon(name="id-badge")
                b-input-group-text(slot="append")
                  icon(name="check", :class="{'text-success': validates.mgrid && validates.exist}")
                b-form-input(
                  type="text",
                  v-model="newUser.mgrid",
                  aria-describedby="inputIDFeedback",
                  :placeholder="$t('ID')",
                  @input="isValidId")
                div.validate-text(v-if="!validates.exist")
                  | {{$t('id_exist')}}
            // 비밀번호
            b-list-group-item
              b-input-group
                //b-input-group-prepend(is-text)
                //  icon(name="lock")
                b-input-group-text(slot="append")
                  icon(name="check", :class="{'text-success': validates.pw}")
                b-form-input(
                  type="password",
                  v-model="newUser.pw",
                  aria-describedby="inputPwFeedback",
                  :placeholder="$t('PW')",
                  @input="isValidPw")
                div.validate-text(v-if="!validates.pw && newUser.pw")
                div.validate-text {{$t(validatePasswordLevels[this.password_level])}}
            // 비밀번호 확인
            b-list-group-item
              b-input-group
                //b-input-group-prepend(is-text)
                //  icon(name="lock")
                b-input-group-text(slot="append")
                  icon(name="check", :class="{'text-success': validates.pwConfirm}")
                b-form-input(
                  type="password",
                  v-model="newUser.pwConfirm",
                  :placeholder="$t('PW_confirm')",
                  @input="isValidPwConfirm")
                div.validate-text(v-if="!validates.pwConfirm && newUser.pwConfirm")
                  | {{$t('password_confirm')}}
            b-list-group-item
              b-input-group
                //b-input-group-prepend(is-text)
                //  icon(name="user")
                b-input-group-text(slot="append")
                  icon(name="check", :class="{'text-success': validates.name}")
                b-form-input(
                  type="text",
                  v-model="newUser.name",
                  :placeholder="$t('name')",
                  @input="isValidName")
        b-card.w-100.mt-2(no-body)
          b-list-group.list-input(flush)
            b-list-group-item
              b-input-group
                //b-input-group-prepend(is-text)
                //  icon(name="envelope")
                b-form-input(type="text", v-model="newUser.email", :placeholder="$t('Email')")
            b-list-group-item
              b-input-group
                //b-input-group-prepend(is-text)
                //  icon(name="phone")
                b-form-input(type="text", v-model="newUser.phone", :placeholder="$t('phone')")
            b-list-group-item
              b-input-group
                //b-input-group-prepend(is-text)
                //  icon(name="flag")
                b-form-input(type="text", v-model="newUser.department", :placeholder="$t('department')")
            b-list-group-item
              b-input-group
                //b-input-group-prepend(is-text)
                //  icon(name="id-badge")
                b-form-input(type="text", v-model="newUser.position", :placeholder="$t('cowork_position')")
        b-card.w-100.mt-3(no-body, v-if="AppState.perm.isApprover")
          div(slot="header") {{$t('setting')}}
          b-list-group.list-input(flush)
            b-list-group-item
              b-input-group
                b-col(cols='2')
                  div.d-flex
                    //b-input-group-prepend(is-text)
                    //  icon(name="id-badge")
                    b-input-group-prepend(is-text)
                      span.approver {{$t('submanager-right')}}
                      i.fas.fa-question-circle.fa-lg(@click="helpManager")
                b-input-group-prepend(is-text)
                  b-col
                    switches.lmm-switch(
                      v-model="enabled",
                      theme="bootstrap",
                      :color="enabled ? 'primary' : 'default'",
                      @input="userTypeChange")
            b-list-group-item
              //b-list-group-item
              //  b-row
              //    b-col.essential(cols="2") *
              //      div.d-inline.ml-1 {{$t('ID')}}
              //    b-col(cols="10") {{user.mgrid}}
              b-input-group
                b-col(cols='2')
                  div.d-flex
                    //b-input-group-prepend(is-text)
                    //  icon(name="file-signature")
                    b-input-group-prepend(is-text)
                      span.approver {{$t('approval-apply')}}
                b-input-group-prepend(is-text)
                  b-col
                    switches.lmm-switch(
                      v-model="newUser.use_approval",
                      theme="bootstrap",
                      :color="newUser.use_approval ? 'primary' : 'default'")
            b-list-group-item
              b-input-group.group-style
                b-col(cols='2')
                  div.d-flex
                    //b-input-group-prepend(is-text)
                    //  icon(name="user")
                    b-input-group-prepend(is-text)
                      span.approver {{$t('approver')}}
                div {{addManagerListener}}
                b-btn.btn-style.ml-4(size="sm", variant="secondary", @click="onModal" style="min-width: 60px;") {{$t('selete')}}
        b-row.d-flex.flex-row-reverse.mr-2.mt-2(style="padding-right: 1rem;")
          b-btn.mt-2.save-btn(@click="next", size="sm") {{$t('save')}}
          b-btn.mt-2.mr-1(@click="cancel" size="sm" style="") {{$t('cancel')}}
</template>

<script>
import _ from 'lodash'
import Switches from 'vue-switches'
import {UsersAPI, CheckAPI, ApprovalsAPI, CompanyFunctionAPI} from '@/api'
import { HeaderWithoutMenu } from '@/components/mixins/header'
import ToggleBox from '@/components/mixins/togglebox'
import Editable from '../mixins/editable'
import store from "store";

export default {
  name: 'join-sub-component',
  components: { HeaderWithoutMenu, ToggleBox, Switches, Editable },
  computed: {
    addManagerListener () {
      this.AppState.$on('send-department-head-data', data => {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.selectedManager = data.selectedManager
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.manager.id = data.id
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.manager.name = data.name
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.newUser.approver_fk = data.pk
      })
      return this.selectedManager ?
          this.manager.id + '(' + this.manager.name + ')' : ''
    },
  },
  methods: {
    userTypeChange () {
      if (this.enabled) {
        this.newUser.user_type = 6
      } else {
        this.newUser.user_type = 1
      }
    },
    helpManager () {
      this.AppState.$emit('show-helpOTP-dialog', {
        title: 'LinkMeMine',
        context: {path: 'help_manager'}
      })
    },
    next () {
      const vd = this.validates
      if (!vd.mgrid) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'invalid_id'}
        })
        return
      }
      if (!vd.exist) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'id_exist'}
        })
        return
      }
      if (!vd.pw) {
        switch (this.password_level){
          case 0:
            this.AppState.$emit('show-message-dialog', {
              title: 'LinkMeMine',
              context: {path: 'password_level0'}
            })
            break;
          case 1:
            this.AppState.$emit('show-message-dialog', {
              title: 'LinkMeMine',
              context: {path: 'password_level1'}
            })
            break;
          case 2:
            this.AppState.$emit('show-message-dialog', {
              title: 'LinkMeMine',
              context: {path: 'password_level2'}
            })
            break;
          case 3:
            this.AppState.$emit('show-message-dialog', {
              title: 'LinkMeMine',
              context: {path: 'password_level3'}
            })
            break;
        }
        return
      }
      if (!vd.pwConfirm) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'password_confirm'}
        })
        return
      }
      if (!vd.name) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'name_requirement'}
        })
        return
      }
      if (vd.approver_error) {
        this.AppState.$emit('show-message-dialog', {
          title: 'LinkMeMine',
          context: {path: 'search_manager_405'}
        })
        return
      }
      let params = {
        department: this.newUser.department,
        email: this.newUser.email,
        flag_recept_mail: this.newUser.flagReceptMail,
        mgrid: this.newUser.mgrid,
        name: this.newUser.name,
        phone: this.newUser.phone,
        position: this.newUser.position,
        pw: this.newUser.pw,
        tel: this.newUser.tel,
        user_type: this.newUser.user_type,
        approver_fk: this.newUser.approver_fk,
        use_approval: this.newUser.use_approval,
        lang_code: 'ko',
        time_zone_id: 32
      }
      // 승인프로세스 적용안할경우 디폴트값 설정
      // 승인프로세스의 의도를 모르겠음... 왜 있는거지?
      if (!params.use_approval) {
        params.user_type = 1
        // params.approver_fk = null
      }

      // 승인프로세스 스위치는 동작시키고, 승인자를 입력하지 않았을 경우 관리자에게 자동으로 붙도록 설정
      if (params.use_approval && !params.approver_fk) {
        params.approver_fk = this.myData.pk
      }
      UsersAPI.post('', params)
        .then(resp => {
          this.AppState.$emit('show-message-dialog', {
            title: 'LinkMeMine',
            context: {path: 'created_user'}
          })
          this.$router.push({name: 'managers'})
        })
    },
    isValidPw () {
      let pw = this.newUser.pw
      switch (this.password_level) {
        case 0:
          this.validates.pw = /^.{4,12}$/.test(pw);
          break;
        case 1:
          this.validates.pw = /^(?=.*?[a-zA-Z])(?=.*?[0-9]).{6,12}$/.test(pw);
          break;
        case 2:
          this.validates.pw = /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(pw);
          break;
        case 3:
          this.validates.pw = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(pw);
          break;
        default:
          alert('비밀번호 난이도 설정이 올바르지 않습니다.');
          break
      }
    },
    isValidPwConfirm () {
      let pw = this.newUser.pw
      let pwConfirm = this.newUser.pwConfirm
      if (pwConfirm && pw === pwConfirm) {
        this.validates.pwConfirm = true
      } else {
        this.validates.pwConfirm = false
      }
    },
    isValidName () {
      this.validates.name = Boolean(this.newUser.name)
    },
    isValidId: _.debounce(function () {
      let id = this.newUser.mgrid
      if (!id) {
        this.validates.mgrid = false
        this.validates.exist = true
        return
      }
      // eslint-disable-next-line no-useless-escape
      if (/^[a-zA-Z0-9@._\-]{4,38}$/g.test(id)) {
        this.validates.mgrid = true
        let params = {
          timestamp: _.now(),
          type: 'mail',
          value: id
        }
        CheckAPI.get('', {params})
          .then(({data}) => {
            this.validates.exist = data.objects.available
          })
      } else {
        this.validates.mgrid = false
      }
    }),
    isValidApprover: _.debounce(function () {
      let approver = this.newUser.approver
      let params = {
        name: approver
      }
      if (params.name !== '') {
        ApprovalsAPI.get('search', {params})
          .then(({data}) => {
            if (data.status === 200) {
              this.newUser.approver_fk = data.objects[0].pk
              this.validates.approver = true
              this.validates.approver_null = false
              this.validates.approver_blank= false
              this.validates.approver_error = false
            } else {
              this.validates.approver = false
              this.validates.approver_null = false
              this.validates.approver_blank= false
              this.validates.approver_error = true
            }
          })
      } else {
        this.newUser.approver_fk = 0
        this.validates.approver_null = false
        this.validates.approver_blank = true
        this.validates.approver_error = false
      }
      
    }),
    async getData () {
      const resp = await CompanyFunctionAPI.get()
      this.password_level = resp.data.objects[0].password_level
    },
    onModal () {
      let params = {
        title: 'LinkMeMine',
        context: {path: 'add_manager'},
      }
      this.AppState.$emit('show-list-modal-dialog', params)
    },
    getUserData () {
      this.myData = store.get('user')
    },
    cancel() {
      this.$router.push({name: 'managers'})
    }
  },
  mounted() {
    this.getData()
    this.getUserData()
  },
  data () {
    return {
      newUser: {
        mgrid: null,
        name: null,
        phone: null,
        position: null,
        pw: null,
        pwConfirm: null,
        tel: null,
        flagReceptMail: null,
        email: null,
        department: null,
        user_type: null,
        approver: null,
        approver_fk: null,
        use_approval: false
      },
      validates: {
        mgrid: false,
        exist: true,
        name: false,
        pw: false,
        pwConfirm: false,
        approver: false,
        approver_null: true,
        approver_blank: false,
        approver_error: false
      },
      validatePasswordLevels: [
        'password_level0',
        'password_level1',
        'password_level2',
        'password_level3',
      ],
      apply: false,
      enabled: false,
      useRefresh: false,
      password_level: 0,
      myData: null,
      user: {
        searchManager: ''
      },
      wait: {
        searchManager: false
      },
      selectedManager: false,
      manager: {
        id: null,
        name: null,
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.row, .col, .container-fluid, .col-12 {
  margin: 0;
  padding: 0;
}

.title {
  font-size: 1.3rem;
  font-weight: bold;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

.list-input {
  .list-group-item {
    padding: 4px;
  }
  .form-control {
    border: 0;
    &:focus { box-shadow: none; }
  }
  .input-group-text {
    color: #ccc;
    border: 0;
    background-color: transparent;
    min-width: 46px;
    svg { margin: 0 auto; }
  }
  .approver {
    color: dimgrey;
  }
  .fas {
    margin-left: 5px;
    cursor: pointer;
  }
}

.validate-text {
  font-size: 10px;
  line-height: 36px;
  color: #bdbdbd;
}





.group-style {
  align-items: center;
}

.card {
  border-radius: 0;
  > .card-header {
    border-bottom: 1px solid #D2D2D2;
    font-size: 1.2rem;
    font-weight: 500;
  }
}

.d-flex > .btn {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  font-weight: 600;
  width: 4rem;
  border-radius: 0;
  height: 1.5rem;
}

.btn-secondary {
  color: black !important;
  background-color: #FFFFFF;
  width: 3rem;
  font-weight: 400;
}

.btn-primary {
  color: black;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.save-btn {
  color: white !important;
  background-color: $mainTheme !important;
  border: 1px solid $mainTheme !important;
}

.save-btn:hover {
  color: white !important;
  background-color: $hover !important;
  border: 1px solid $hover !important;
  font-weight: 600;
}

.col-1 {
  padding: 0;
}
</style>
